var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabletAltSolidWithCoinsSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg845",
    viewBox: "0 0 448 512",
    role: "img",
    className: "svg-inline--fa fa-tablet-alt fa-w-14",
    "data-icon": "tablet-alt",
    "data-prefix": "fas",
    focusable: "false",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs849"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path843",
    d: "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.530393
    },
    fill: "white",
    d: "m 82.820971,291.18057 v 21.56458 c 0,17.82738 47.904869,32.32161 106.950429,32.32161 59.04554,0 106.95042,-14.49423 106.95042,-32.32161 v -21.56458 c -23.00548,14.69622 -65.0615,21.56458 -106.95042,21.56458 -41.88892,0 -83.94494,-6.86836 -106.950429,-21.56458 z M 261.07167,151.13706 c 59.04556,0 106.95043,-14.49422 106.95043,-32.32161 0,-17.8274 -47.90487,-32.321624 -106.95043,-32.321624 -59.04554,0 -106.95041,14.494224 -106.95041,32.321624 0,17.82739 47.90487,32.32161 106.95041,32.32161 z M 82.820971,238.20342 v 26.0593 c 0,17.82739 47.904869,32.32161 106.950429,32.32161 59.04554,0 106.95042,-14.49422 106.95042,-32.32161 v -26.0593 c -23.00548,17.17085 -65.11721,26.0593 -106.95042,26.0593 -41.83322,0 -83.94494,-8.88845 -106.950429,-26.0593 z m 231.725919,5.55527 c 31.91802,-5.60577 53.47521,-16.0093 53.47521,-27.97839 v -21.56458 c -12.92317,8.28241 -31.91801,13.93869 -53.47521,17.42337 z M 189.7714,167.29787 c -59.04556,0 -106.950429,18.0799 -106.950429,40.40203 0,22.32211 47.904869,40.40201 106.950429,40.40201 59.04554,0 106.95042,-18.0799 106.95042,-40.40201 0,-22.32213 -47.90488,-40.40203 -106.95042,-40.40203 z m 122.15744,28.43293 c 33.422,-5.45428 56.09326,-16.16081 56.09326,-28.43293 V 145.7333 c -19.77468,12.67613 -53.75372,19.49397 -89.51528,21.11005 16.43249,7.22186 28.52012,16.91834 33.42202,28.88745 z",
    id: "path1444"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletAltSolidWithCoinsSolid);
export default __webpack_public_path__ + "static/media/tablet-alt-solid-with-coins-solid.7a4677aaa1e422e351bda6c6f4e3aa06.svg";
export { ForwardRef as ReactComponent };